// action types for payment types
export const SET_PAYMENTTYPES_DATA = "SET_PAYMENTTYPES_DATA";
export const ADD_PAYMENTTYPE = "ADD_PAYMENTTYPE";
export const UPDATE_PAYMENTTYPE = "UPDATE_PAYMENTTYPE";
export const DELETE_PAYMENTTYPE = "DELETE_PAYMENTTYPE";
